import { render } from "./Toolbar.vue?vue&type=template&id=9d22258a&scoped=true&ts=true"
import script from "./Toolbar.vue?vue&type=script&lang=ts"
export * from "./Toolbar.vue?vue&type=script&lang=ts"

import "./Toolbar.vue?vue&type=style&index=0&id=9d22258a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d22258a"]])

export default __exports__